import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            <p>&copy; {new Date().getFullYear()} Paddling Paws. All rights reserved.</p>
            <p>
                Contact us at: <a href="mailto:info@paddlingpaws.org">info@paddlingpaws.org</a>
            </p>
        </footer>
    );
}

export default Footer;
